import { InertiaApp } from "@inertiajs/inertia-react"
import { InertiaProgress } from "@inertiajs/progress"
import React from "react"
import { render } from "react-dom"
import route from "ziggy"
import { Ziggy } from "./ziggy"
import { can } from "./utils"
import "typeface-inter"
import "whatwg-fetch"

const app = document.getElementById("app")
const pageData = JSON.parse(app.dataset.page)

if (pageData.props.team) {
  Ziggy.defaultParameters = { team: pageData.props.team.domain }
}
window.route = route
window.Ziggy = Ziggy
window.can = can

InertiaProgress.init({
  color: "#76a9fa",
})

render(
  <InertiaApp
    initialPage={pageData}
    resolveComponent={name => import(`./Pages/${name}`).then(module => module.default)}
  />,
  app
)
